import React from 'react'

const Manual_crear_plantilla_rapida_email = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear una plantilla rápida para e-mail
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_una_plantilla_rapida_para_e-mail__RxNSQVHSTQKFeysaG_NGQQ?as=scrollable"
          className="scribe-iframe-general-79"
          width="100%"
          height="4500"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_crear_plantilla_rapida_email
